import { Aside, LogoContainer, Logo, Ul } from "./style";

import logo from "assets/images/new-logo.svg";
import logo1 from "assets/images/new-logo.svg";
import { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { dispatch } from "store";
import { RootState } from "../../../store/root-reducer/index";
import { setSideBarClosed, setSideBarOpened } from "store/user-slice";

interface SidebarProps {
  children: ReactNode;
}
const Sidebar: FC<SidebarProps> = ({ children }) => {
  const { isSidebarExpanded } = useSelector((state: RootState) => state.user);
  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth < 1050) {
  //       dispatch(setSideBarClosed());
  //     }
  //     if (window.innerWidth > 1050) {
  //       dispatch(setSideBarOpened());
  //     }
  //   };

  //   window.addEventListener("resize", handleResize);
  //   handleResize();

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, [dispatch]);
  const [isOverlay, setIsOverlay] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isSmall = window.innerWidth <= 1200;
      setIsOverlay(isSmall);
      if (window.innerWidth < 1200) {
        dispatch(setSideBarClosed());
      } else {
        dispatch(setSideBarOpened());
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

   const handleExpandSidebar = () => {
      if (isSidebarExpanded) {
        dispatch(setSideBarClosed());
      } else {
        dispatch(setSideBarOpened());
      }
    };

  return (
    <Aside issidebarexpanded={isSidebarExpanded}  isoverlay={isOverlay} className="no-print">
      <LogoContainer issidebarexpanded={isSidebarExpanded}>
        <Logo style={{ width: "100px", height: "100px" }}
        onClick={handleExpandSidebar}
          issidebarexpanded={isSidebarExpanded}
          src={isSidebarExpanded ? logo : logo1}
          alt="Logo.png"
        />
      </LogoContainer>
      <Ul>{children}</Ul>
    </Aside>
  );
};

export default Sidebar;
